import React, { useState, useEffect, useContext } from 'react'
import ImageWithBasePath from '../../core/img/imagewithbasebath'
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Calendar, theme } from 'antd';
import Select from 'react-select';
import { TimePicker } from 'antd'
// import { ConfigProvider } from 'antd';
import { createShoutoutOrder } from '../../services/orderService';
import Navbar from '../landingpage/sections/Navbar';
import { AuthContext } from '../../context/AuthContext';

const BookingPopup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(1);
  const [celebrity, setCelebrity] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState(null);
  const orderResult = useState(null);
  const { user } = useContext(AuthContext);

  // Form data that persists across all steps
  const [formData, setFormData] = useState({
    shoutoutType: '',
    recipientFirstName: '',
    recipientLastName: '',
    recipientPhone: '',
    message: '',
    messageType: 'video',
    venue: '',
    selectedDate: null,
    selectedTime: null,
    paymentMethod: 'onemoney',
  });

  // Get celebrity data from URL parameters
  // Get celebrity data from URL parameters
  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const celebId = searchParams.get('celebId');
    const celebName = searchParams.get('name');
    const celebCategory = searchParams.get('category');
    const celebImage = searchParams.get('image');
    const celebPrice = searchParams.get('price');
    const shoutoutPricing = searchParams.get('shoutoutPricing');

    if (celebId || celebName) {
      const parsedShoutoutPricing = shoutoutPricing ? JSON.parse(shoutoutPricing) : [];

      // Set initial price - use the first shoutout price or fallback
      const initialPrice = parsedShoutoutPricing.length > 0
        ? parsedShoutoutPricing[0].price
        : (celebPrice ? parseFloat(celebPrice) : 25);

      setCelebrity({
        id: celebId || 'unknown',
        name: decodeURIComponent(celebName || 'Celebrity'),
        category: decodeURIComponent(celebCategory || 'Entertainer'),
        image: decodeURIComponent(celebImage || 'assets/img/doctor-grid/celeb.jpg'),
        price: initialPrice,
        // Store shoutout pricing
        shoutoutPricing: parsedShoutoutPricing,
      });

      // Auto-select the first shoutout type if available
      if (parsedShoutoutPricing.length > 0) {
        setFormData(prev => ({
          ...prev,
          shoutoutType: parsedShoutoutPricing[0].shoutoutId
        }));
      }
    } else {
      setCelebrity({
        id: '1',
        name: 'Celebrity',
        category: 'Entertainer',
        image: 'assets/img/doctor-grid/celeb.jpg',
        price: 25,
        shoutoutPricing: [],
        rating: 4.5
      });
    }
  }, [location.search]);

  const updateFormData = (field, value) => {
    setFormData(prev => {
      const newData = { ...prev, [field]: value };

      // Update price when shoutout type changes
      if (field === 'shoutoutType' && value && celebrity) {
        const selectedShoutout = celebrity.shoutoutPricing.find(
          s => s.shoutoutId === value
        );
        if (selectedShoutout) {
          setCelebrity(prevCeleb => ({
            ...prevCeleb,
            price: selectedShoutout.price
          }));
        }
      }

      return newData;
    });
  };

  // Get shoutout options for dropdown
  const getShoutoutOptions = () => {
    if (!celebrity || !celebrity.shoutoutPricing || celebrity.shoutoutPricing.length === 0) {
      return [
        { value: "6895b7d08a07da4b1fb8cc06", label: "Birthday" },
        { value: "6895b7ba8a07da4b1fb8cc03", label: "Anniversary" },
      ];
    }

    return celebrity.shoutoutPricing.map(shoutout => ({
      value: shoutout.shoutoutId,
      label: shoutout.shoutoutName,
      price: shoutout.price
    }));
  };

  // Get current selected shoutout name
  const getSelectedShoutoutName = () => {
    const options = getShoutoutOptions();
    const selected = options.find(opt => opt.value === formData.shoutoutType);
    return selected ? selected.label : 'Shoutout';
  };

  const handleNext = () => {
    if (currentStep === 1) {
      if (!formData.shoutoutType || !formData.recipientFirstName || !formData.recipientLastName) {
        alert('Please fill in all required fields');
        return;
      }
    } else if (currentStep === 2 && formData.messageType === 'in-person' && !formData.venue.trim()) {
      alert('Please enter the venue for the in-person visit');
      return;
    } else if (currentStep === 3) {
      // VALIDATE DATE IS IN FUTURE
      if (!formData.selectedDate || !formData.selectedTime) {
        alert('Please select both date and time');
        return;
      }

      // Check if selected date/time is in the future
      const selectedDateTime = new Date(
        formData.selectedDate.year(),
        formData.selectedDate.month(),
        formData.selectedDate.date(),
        formData.selectedTime.hour(),
        formData.selectedTime.minute()
      );
      const now = new Date();

      if (selectedDateTime <= now) {
        alert('Please select a future date and time for delivery');
        return;
      }
    }

    setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    setCurrentStep(currentStep - 1);
  };

  const handleClose = () => {
    navigate(-1);
  };

  const handleSubmitOrder = async () => {
    setIsSubmitting(true);
    setSubmitError(null);

    try {
      const shoutoutId = celebrity.id === "6894f2f9132e145b92d2fbef"
        ? "6895b7d08a07da4b1fb8cc06"
        : formData.shoutoutType;

      let deliveryDateTime;

      if (formData.selectedDate && formData.selectedTime) {
        const year = formData.selectedDate.year();
        const month = formData.selectedDate.month();
        const day = formData.selectedDate.date();
        const hours = formData.selectedTime.hour();
        const minutes = formData.selectedTime.minute();

        const localDate = new Date(year, month, day, hours, minutes);
        deliveryDateTime = localDate.toISOString();
      } else {
        deliveryDateTime = new Date().toISOString();
      }

      const orderData = {
        celebrityId: celebrity.id,
        shortoutId: shoutoutId,
        message: formData.message,
        recipientName: `${formData.recipientFirstName} ${formData.recipientLastName}`.trim(),
        deliveryDate: deliveryDateTime,
        phoneNumber: formData.recipientPhone,
        messageType: formData.messageType,
        venue: formData.venue || ''
      };

      console.log('📦 Order data being sent:', orderData);

      const response = await createShoutoutOrder(orderData);
      console.log('✅ Backend response:', response);

      setCurrentStep(5);

    } catch (error) {
      console.error('❌ Order submission error:', error);

      // Check for insufficient funds error
      const errorMessage = error.message || 'Failed to create order. Please try again.';
      const isInsufficientFunds =
        errorMessage.toLowerCase().includes('insufficient') ||
        errorMessage.toLowerCase().includes('balance') ||
        errorMessage.toLowerCase().includes('wallet') ||
        errorMessage.toLowerCase().includes('fund');

      if (isInsufficientFunds) {
        setSubmitError({
          message: errorMessage,
          isInsufficientFunds: true
        });
      } else {
        setSubmitError({
          message: errorMessage,
          isInsufficientFunds: false
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  // Add this function after the handleSubmitOrder function
  const handleNavigateToTopUp = () => {
    if (user && user.userType === 'celeb') {
      // Navigate to celebrity account for top-up
      navigate('/celeb-account');
    } else {
      // Navigate to fan account for top-up (default)
      navigate('/fan-account');
    }
    // You can also pass state to preselect the deposit tab:
    // navigate('/fan-account', { state: { activeTab: 'deposit' } });
  };

  const { token } = theme.useToken();
  const wrapperStyle = {
    width: '100%',
    border: `1px solid ${token.colorBorderSecondary}`,
    borderRadius: token.borderRadiusLG,
  };

  const Speciality = [
    { value: "6895b7d08a07da4b1fb8cc06", label: "Birthday" },
    { value: "6895b7ba8a07da4b1fb8cc03", label: "Anniversary" },
  ];

  if (!celebrity) {
    return (
      <div className="modal booking-modal show" style={{ display: "block", zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-body text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p className="mt-2">Loading celebrity information...</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (

    <>
      <Navbar />
      <div className="modal booking-modal show" style={{ display: "block", zIndex: 1050 }}>
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Ordering a shoutout with {celebrity.name}</h5>
              <button type="button" className="btn-close" onClick={handleClose}></button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-12 mx-auto">
                  {/* Progress Steps */}
                  <div className="booking-wizard">
                    <ul className="form-wizard-steps d-sm-flex align-items-center justify-content-center">
                      {[1, 2, 3, 4, 5].map(step => (
                        <li key={step} className={
                          currentStep === step
                            ? 'progress-active'
                            : currentStep > step
                              ? 'progress-activated'
                              : ''
                        }>
                          <div className="profile-step">
                            <span className="multi-steps">{step}</span>
                            <div className="step-section">
                              <h6>
                                {step === 1 && 'Details'}
                                {step === 2 && 'Message Type'}
                                {step === 3 && 'Date & Time'}
                                {step === 4 && 'Payment'}
                                {step === 5 && 'Confirmation'}
                              </h6>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                  </div>

                  {/* Form Steps */}
                  <div className="booking-widget multistep-form mb-5">
                    {/* Step 1: Shoutout Details */}
                    {currentStep === 1 && (
                      <div className="card booking-card mb-0">
                        <div className="card-header">
                          <div className="booking-header pb-0">
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex align-items-center flex-wrap">
                                  <span className="avatar avatar-xxxl avatar-rounded me-2">
                                    <img
                                      className="avatar-img rounded-circle"
                                      src={celebrity.image}
                                      width={41}
                                      alt="pik"
                                    />
                                  </span>
                                  <div>
                                    <h4 className="mb-1">
                                      {celebrity.name}
                                    </h4>
                                    <p className="text-indigo mb-3 fw-medium">{celebrity.category}</p>
                                    <p className="mb-0">
                                      <i className="isax isax-money me-2" />
                                      ${celebrity.price.toFixed(2)} for {getSelectedShoutoutName()}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body booking-body">
                          <div className="card mb-0">
                            <div className="card-body pb-1">
                              <div className="mb-4">
                                <label className="form-label">Select shoutout type *</label>
                                <Select
                                  className="select"
                                  options={getShoutoutOptions()}
                                  placeholder="Select shoutout type"
                                  value={getShoutoutOptions().find(opt => opt.value === formData.shoutoutType)}
                                  onChange={(selected) => updateFormData('shoutoutType', selected?.value || '')}
                                  isSearchable={true}
                                />
                              </div>
                              <div className="row">
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">Recipient First Name *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={formData.recipientFirstName}
                                      onChange={(e) => updateFormData('recipientFirstName', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-6 col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">Recipient Last Name *</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={formData.recipientLastName}
                                      onChange={(e) => updateFormData('recipientLastName', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="mb-3">
                                    <label className="form-label">Phone Number</label>
                                    <input
                                      type="text"
                                      className="form-control"
                                      value={formData.recipientPhone}
                                      onChange={(e) => updateFormData('recipientPhone', e.target.value)}
                                    />
                                  </div>
                                </div>
                                <div className="col-lg-12">
                                  <div className="mb-3">
                                    <label className="form-label">Message</label>
                                    <textarea
                                      className="form-control"
                                      rows={3}
                                      value={formData.message}
                                      onChange={(e) => updateFormData('message', e.target.value)}
                                      placeholder="What should the celebrity say in the shoutout?"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div className="d-flex align-items-center justify-content-between">
                            <button className="btn btn-md btn-dark rounded-pill" onClick={handleClose}>
                              <i className="isax isax-arrow-left-2 me-1" />
                              Cancel
                            </button>
                            <button className="btn btn-md btn-primary-gradient rounded-pill" onClick={handleNext}>
                              Next: Message Type
                              <i className="isax isax-arrow-right-3 ms-1" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Step 2: Message Type */}
                    {currentStep === 2 && (
                      <div className="card booking-card mb-0">
                        <div className="card-header">
                          <div className="booking-header pb-0">
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex align-items-center flex-wrap">
                                  <span className="avatar avatar-xxxl avatar-rounded me-2">
                                    <img
                                      className="avatar-img rounded-circle"
                                      src={celebrity.image}
                                      width={41}
                                      alt="pik"
                                    />
                                  </span>
                                  <div>
                                    <h4 className="mb-1">{celebrity.name}</h4>
                                    <p className="text-indigo mb-3 fw-medium">{celebrity.category}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-body booking-body">
                          <div className="card mb-0">
                            <div className="card-body pb-1">
                              <h6 className="mb-3">Select Message Type *</h6>
                              <div className="row">
                                {[
                                  { value: 'video', label: 'Video', icon: 'isax-video5' },
                                  { value: 'message', label: 'Message', icon: 'isax-messages-15' },
                                  { value: 'audio', label: 'Audio', icon: 'isax-microphone-2' },
                                  { value: 'in-person', label: 'In-Person Visit', icon: 'isax-people' }
                                ].map((type) => (
                                  <div key={type.value} className="col-xl-3 col-md-3 col-sm-6 mb-3">
                                    <div className="radio-select text-center">
                                      <input
                                        className="form-check-input"
                                        name="messageType"
                                        type="radio"
                                        id={type.value}
                                        checked={formData.messageType === type.value}
                                        onChange={() => updateFormData('messageType', type.value)}
                                      />
                                      <label className="form-check-label" htmlFor={type.value}>
                                        <i className={`isax ${type.icon}`} />
                                        <span className="service-title d-block">{type.label}</span>
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </div>

                              {formData.messageType === 'in-person' && (
                                <div className="row mt-3">
                                  <div className="col-lg-12">
                                    <div className="mb-3">
                                      <label className="form-label">Venue for In-Person Visit *</label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        value={formData.venue}
                                        onChange={(e) => updateFormData('venue', e.target.value)}
                                        placeholder="Enter venue address"
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div className="d-flex align-items-center justify-content-between">
                            <button className="btn btn-md btn-dark rounded-pill" onClick={handlePrev}>
                              <i className="isax isax-arrow-left-2 me-1" />
                              Back
                            </button>
                            <button className="btn btn-md btn-primary-gradient rounded-pill" onClick={handleNext}>
                              Next: Date & Time
                              <i className="isax isax-arrow-right-3 ms-1" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* Step 3: Date & Time */}
                    {currentStep === 3 && (
                      <div className="card booking-card mb-0">
                        <div className="card-header">
                          <div className="booking-header pb-0">
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex align-items-center flex-wrap">
                                  <span className="avatar avatar-xxxl avatar-rounded me-2">
                                    <img
                                      className="avatar-img rounded-circle"
                                      src={celebrity.image}
                                      width={41}
                                      alt="pik"
                                    />
                                  </span>
                                  <div>
                                    <h4 className="mb-1">{celebrity.name}</h4>
                                    <p className="text-indigo mb-3 fw-medium">{celebrity.category}</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-body booking-body">
                          <div className="card mb-0">
                            <div className="card-body pb-1">
                              <div className="row">
                                <div className="col-lg-5">
                                  <div className="card">
                                    <div className="card-body p-2 pt-3">
                                      <div style={wrapperStyle}>
                                        <Calendar
                                          fullscreen={false}
                                          onSelect={(date) => updateFormData('selectedDate', date)}
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="col-lg-7">
                                  <div className="card booking-wizard-slots">
                                    <div className="card-body">
                                      <h6 className="fs-14 mb-3">Select Delivery Time *</h6>
                                      <div className="form-wrap">
                                        <div className="form-icon">
                                          <TimePicker
                                            value={formData.selectedTime}
                                            onChange={(time) => updateFormData('selectedTime', time)}
                                            className="form-control timepicker1 business"
                                            placeholder="Select delivery time"
                                            format="HH:mm"
                                            minuteStep={5}
                                            showNow={false}
                                            style={{ width: '100%' }}
                                            needConfirm={false}
                                          />
                                          <span className="icon">
                                            <i className="fa-solid fa-clock" />
                                          </span>
                                        </div>
                                        <div className="form-text mt-2">
                                          <small className="text-muted">
                                            Choose the time when you want the shoutout to be delivered
                                          </small>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-footer">
                          <div className="d-flex align-items-center justify-content-between">
                            <button className="btn btn-md btn-dark rounded-pill" onClick={handlePrev}>
                              <i className="isax isax-arrow-left-2 me-1" />
                              Back
                            </button>
                            <button className="btn btn-md btn-primary-gradient rounded-pill" onClick={handleNext}>
                              Next: Payment
                              <i className="isax isax-arrow-right-3 ms-1" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}

                    {currentStep === 4 && (
                      <div className="card booking-card mb-0">
                        <div className="card-header">
                          <div className="booking-header pb-0">
                            <div className="card mb-0">
                              <div className="card-body">
                                <div className="d-flex align-items-center flex-wrap">
                                  <span className="avatar avatar-xxxl avatar-rounded me-2">
                                    <img
                                      className="avatar-img rounded-circle"
                                      src={celebrity.image}
                                      width={41}
                                      alt="pik"
                                    />
                                  </span>
                                  <div>
                                    <h4 className="mb-1">{celebrity.name}</h4>
                                    <p className="text-indigo mb-3 fw-medium">{celebrity.category}</p>
                                    <p className="mb-0">${celebrity.price} for a shoutout</p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="card-body booking-body">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="card mb-3">
                                <div className="card-body">
                                  <h6 className="mb-3">Payment Method *</h6>
                                  <div className="payment-tabs">
                                    <div className="form-check mb-3">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        name="paymentMethod"
                                        id="onemoney"
                                        checked={formData.paymentMethod === 'onemoney'}
                                        onChange={() => updateFormData('paymentMethod', 'onemoney')}
                                      />
                                      <label className="form-check-label" htmlFor="onemoney">
                                        <ImageWithBasePath
                                          src="assets/img/icons/payment-card.PNG"
                                          className="me-2"
                                          alt="One Money"
                                        />
                                        One Money
                                      </label>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="card mb-0">
                                <div className="card-body">
                                  <h6 className="mb-3">Order Summary</h6>
                                  <div className="mb-2">
                                    <small className="text-muted">Shoutout Type:</small>
                                    <p className="mb-0">{Speciality.find(opt => opt.value === formData.shoutoutType)?.label || 'Birthday'}</p>
                                  </div>
                                  <div className="mb-2">
                                    <small className="text-muted">Message Type:</small>
                                    <p className="mb-0">{formData.messageType}</p>
                                  </div>
                                  {formData.selectedDate && (
                                    <div className="mb-2">
                                      <small className="text-muted">Date & Time:</small>
                                      <p className="mb-0">
                                        {formData.selectedDate.format('MMM DD, YYYY')} at {formData.selectedTime.format('h:mm A')}
                                      </p>
                                    </div>
                                  )}
                                  <div className="border-top pt-3 mt-3">
                                    <div className="d-flex justify-content-between mb-2">
                                      <span>Shoutout Fee:</span>
                                      <span>${celebrity.price}</span>
                                    </div>
                                    <div className="d-flex justify-content-between fw-bold fs-5">
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="card-footer">
                          <div className="d-flex align-items-center justify-content-between">
                            <button className="btn btn-md btn-dark rounded-pill" onClick={handlePrev}>
                              <i className="isax isax-arrow-left-2 me-1" />
                              Back
                            </button>
                            <button
                              className="btn btn-md btn-primary-gradient rounded-pill"
                              onClick={handleSubmitOrder}
                              disabled={isSubmitting}
                            >
                              {isSubmitting ? (
                                <>
                                  <span className="spinner-border spinner-border-sm me-2" />
                                  Processing...
                                </>
                              ) : (
                                <>
                                  Confirm & Pay ${celebrity.price}
                                  <i className="isax isax-arrow-right-3 ms-1" />
                                </>
                              )}
                            </button>
                          </div>

                          {/* Updated Error Display */}
                          {submitError && (
                            <div className="mt-3">
                              <div className={`alert ${submitError.isInsufficientFunds ? 'alert-warning' : 'alert-danger'} mb-0 p-2`}>
                                <div className="d-flex align-items-center">
                                  <i className={`fa-solid ${submitError.isInsufficientFunds ? 'fa-wallet' : 'fa-circle-exclamation'} me-2`}></i>

                                  {/* Bootstrap alert-text class ensures proper color */}
                                  <div className="alert-text me-3">
                                    {submitError.message}
                                  </div>

                                  {submitError.isInsufficientFunds && (
                                    <button
                                      className="btn btn-success btn-sm"
                                      onClick={handleNavigateToTopUp}
                                    >
                                      <i className="fa-solid fa-money-bill-transfer me-1"></i>
                                      Top Up
                                    </button>
                                  )}

                                  {!submitError.isInsufficientFunds && (
                                    <button
                                      className="btn btn-outline-danger btn-sm"
                                      onClick={() => setSubmitError(null)}
                                    >
                                      Dismiss
                                    </button>
                                  )}
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    )}

                    {/* Step 5: Confirmation */}
                    {currentStep === 5 && (
                      <div className="card booking-card">
                        <div className="card-body text-center py-5">
                          <i className="isax isax-tick-circle5 text-success" style={{ fontSize: '4rem' }} />
                          <h4 className="mt-3 mb-2">Order Confirmed!</h4>
                          <p className="text-muted mb-1">Order #: {orderResult?._id || 'Processing...'}</p>
                          <p className="text-muted mb-1">Status: {orderResult?.status || 'Confirmed'}</p>
                          <p className="text-muted mb-4">
                            Your shoutout order with {celebrity.name} has been successfully placed.
                          </p>
                          <div className="d-grid gap-2 d-md-flex justify-content-center">
                            <Link to="/celebs" className="btn btn-primary rounded-pill me-md-2">
                              Book Another Shoutout
                            </Link>
                            <Link to="/fan-dashboard" className="btn btn-outline-primary rounded-pill me-md-2">
                              View Order Details
                            </Link>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BookingPopup;
